export interface PillColor {
  name: string;
  bg: string;
  text: string;
}

export enum PILL_KEY {
  Gray = 'gray',
  LightBlue = 'light-blue',
  Blue = 'blue',
  Teal = 'teal',
  Green = 'green',
  Pink = 'pink',
  Yellow = 'yellow',
  Red = 'red'
}

export const PILL_COLORS: Record<PILL_KEY, PillColor> = {
  [PILL_KEY.Gray]: { name: 'Gray', bg: '#DEDEDE', text: '#000000' },
  [PILL_KEY.LightBlue]: { name: 'Light Blue', bg: '#DBF6FF', text: '#000000' },
  [PILL_KEY.Blue]: { name: 'Blue', bg: '#CDE0FF', text: '#000000' },
  [PILL_KEY.Teal]: { name: 'Teal', bg: '#BEE9E7', text: '#000000' },
  [PILL_KEY.Green]: { name: 'Green', bg: '#D5FFD5', text: '#000000' },
  [PILL_KEY.Pink]: { name: 'Pink', bg: '#FFBFDB', text: '#000000' },
  [PILL_KEY.Yellow]: { name: 'Yellow', bg: '#FFEFC2', text: '#000000' },
  [PILL_KEY.Red]: { name: 'Red', bg: '#FD8587', text: '#000000' }
};

export const DEFAULT_PILL_COLOR = PILL_COLORS.teal;

export const getPillColor = (key?: PILL_KEY): PillColor => {
  if (key) {
    const color = PILL_COLORS[key];
    if (color) {
      return color;
    }
    //key seems typed, but it's really just a string. If it's ever something unexpected let's be sure to log it.
    console.error(`Pill color with key ${key} not found. Returning default color.`);
  }

  return DEFAULT_PILL_COLOR;
};

export const generateChipStyle = (key?: PILL_KEY): { [key: string]: string } | null => {
  if (!key) return null;
  const pillColor = getPillColor(key);
  return {
    'background-color': pillColor.bg,
    color: pillColor.text,
    '--mat-chip-label-text-color': pillColor.text
  };
};

export const starRatingPlaceholders = [
  'N/A',
  'Ex: Performed Poorly',
  'Ex: Performed Below Expectations',
  'Ex: Met Minimum Expectations',
  'Ex: Performed Above Expectations',
  'Ex: Greatly Exceeded Expectations'
];
